import { isNil } from 'lodash';
import { compose, setDisplayName, withProps } from 'recompose';
import { checkableOptionTypes } from '@nextiva/engagement-ui';
import CheckableQuestionForm from './CheckableQuestionForm';

const fieldFormat = value => (isNil(value) ? {} : value);

export default compose(
  setDisplayName('SingleQuestionForm'),
  withProps({
    type: checkableOptionTypes.SINGLE,
    fieldFormat,
  }),
)(CheckableQuestionForm);
